import { CHART_PREFERENCES_DEFAULT_VALUES, DEFAULT_CHART_PREFERENCES } from './styleConsts'
import { cloneDeep } from 'lodash'
import { getDefaultChartPreferences } from '../../../../../shared/charts/chartPreferences'
import styleTabStyles from './StyleTab.module.scss'
import utilsStyles from './utils.module.scss'
import { ScoopText, ScoopSelector, ScoopColorPicker } from '../../../../ui'

export function renderSelector(label, value, setValue, options) {
    // Normalize options to always be {label, value} format
    const normalizedOptions = options.map((opt) =>
        typeof opt === 'string' ? { label: opt, value: opt } : opt
    )

    return (
        <ScoopSelector
            value={value}
            label={label}
            onChange={(e) => setValue(e.target.value)}
            options={normalizedOptions}
            size="md"
            removeMargin
        />
    )
}

export function renderColorPicker(label, color, setColor) {
    return (
        <div className={utilsStyles.colorPickerColumn}>
            {label && <ScoopText className={styleTabStyles.styleConfigLabel}>{label}</ScoopText>}
            <div className={utilsStyles.colorPickerPadding}>
                <ScoopColorPicker showLabel value={color} onChange={(color) => setColor(color)} />
            </div>
        </div>
    )
}

export function renderBoxSelector(title, selected, onClick) {
    const className = selected
        ? `${utilsStyles.boxSelector} ${utilsStyles.selected}`
        : utilsStyles.boxSelector

    return (
        <div className={className} onClick={onClick}>
            <ScoopText className={utilsStyles.boxSelectorText}>{title}</ScoopText>
        </div>
    )
}

export const getEmptyTheme = () => {
    return JSON.parse(JSON.stringify(DEFAULT_CHART_PREFERENCES))
}

export const propExistsOnObject = (override, prop) => {
    return override && override[prop] !== undefined
}

// Moved to the shared chart module (used by the portal too); re-exported for existing callers.
export { getDefaultChartPreferences }
